import { useMemo } from 'react';
import { defaultGetFilteredItems, defaultLabelGetter } from '../helpers';
export default (_ref => {
  let {
    items,
    itemToString = defaultLabelGetter,
    getFilteredItems = defaultGetFilteredItems,
    inputValue,
    filterBy
  } = _ref;
  const filteredItems = useMemo(() => getFilteredItems({
    inputValue: inputValue || '',
    itemToString,
    allItems: items,
    filterBy
  }), [filterBy, getFilteredItems, inputValue, itemToString, items]);
  return {
    filteredItems
  };
});
//# sourceMappingURL=useFilteredItems.js.map